// Frame pacing (BoardScene.loop): the board renders at full rate only while something moves.

// Endless ambient loops — the clerks' idle bob, the pulsing highlights — carry this gsap `data` tag
// so they don't count as movement; while they are all that's running the board renders at the
// idle rate, which reads the same for motion that slow and small.
export const AMBIENT = 'ambient';

let obscurers = 0;

/**
 * A modal that covers the board (the draft, the results) holds this while it is up; the board then
 * idles at a low frame rate behind it. Returns the release, which is safe to call more than once.
 */
export function obscureBoard(): () => void {
  let held = true;
  obscurers++;
  return () => {
    if (held) obscurers--;
    held = false;
  };
}

export function boardObscured(): boolean {
  return obscurers > 0;
}
